import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _, { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { getJson } from 'session';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import UpdateModal from '../component/UpdateModal';
import * as actions from '../../../action';
import * as c from '../../../constant';
import TaxRevenueInformation from '../component/TaxRevenueInformation';

function ViewBusinessLinesModal({
  updateList,
  businessLinesId,
  businessLinesInfo,
  removeNewBusinessLines,
  getNewBusinessLinesList,
  ordinanceRevisionId,
  newBusinessNaturesId,
  getSingleNewBusinessLines,
  newBusinessLinesInfo,
  activateNewBusinessLines,
  deactivateNewBusinessLines,
  getNewBusinessNaturesList,
  getSingleNewBusinessNatures,
  history,
  getReportAccess,
}) {
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    garbage_code: '',
    license_code: '',
    permit_code: '',
    sanitary_code: '',
  });
  const setModal = useContext(ModalContext);
  const authProfile = getJson('profile') || {};

  useEffect(() => {
    if (_.isEmpty(businessLinesId)) return;
    getSingleNewBusinessLines(newBusinessNaturesId, businessLinesId);
  }, [businessLinesId]);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.BUSINESS_LINES_FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const handleUpdateBusinessLines = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          updateList={updateList}
          businessLinesId={businessLinesId}
          businessLinesInfo={businessLinesInfo}
          ordinanceRevisionId={ordinanceRevisionId}
          newBusinessNaturesId={newBusinessNaturesId}
        />
      ),
      title: 'Update Business Line',
      modalSize: 'modal-lg',
    });
  };

  const handleRemoveBusinessLines = (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to remove this business line?',
      () => {
        removeNewBusinessLines(
          newBusinessNaturesId,
          businessLinesInfo.id,
          () => {
            setModal({ isOpen: false });
            getNewBusinessLinesList(newBusinessNaturesId, {
              ordinance_revision_id: ordinanceRevisionId,
            });
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleDownload = (e) => {
    e.preventDefault();
    const reportAccessArgs = {
      path: `/api/v1/bpls/administrator/report/business_lines/${businessLinesId}/generate`,
      query: {
        email: _.get(authProfile, 'email'),
        ordinance_revision_id: ordinanceRevisionId,
        output: 'D',
      },
    };
    getReportAccess(reportAccessArgs, (response) => {
      const src = `${response?.res?.res?.url || ''}`;
      window.location.href = src;
    });
  };

  const handleActivate = (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to activate this business line?',
      () => {
        activateNewBusinessLines(
          newBusinessNaturesId,
          businessLinesInfo.id,
          {},
          () => {
            getNewBusinessNaturesList();
            history.push(`/bpls/new-business/new-business-natures/${newBusinessNaturesId}`);
            getSingleNewBusinessNatures(newBusinessNaturesId);
            setModal({ isOpen: false });
            getNewBusinessLinesList(newBusinessNaturesId, {
              ordinance_revision_id: ordinanceRevisionId,
            });
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleDeactivate = (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to deactivate this business line?',
      () => {
        deactivateNewBusinessLines(
          newBusinessNaturesId,
          businessLinesInfo.id,
          {},
          () => {
            getNewBusinessNaturesList();
            history.push(`/bpls/new-business/new-business-natures/${newBusinessNaturesId}`);
            getSingleNewBusinessNatures(newBusinessNaturesId);
            setModal({ isOpen: false });
            getNewBusinessLinesList(newBusinessNaturesId, {
              ordinance_revision_id: ordinanceRevisionId,
            });
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const otherFees = _.get(newBusinessLinesInfo, 'included.otherFees', []);

  return (
    <Modal.Body>
      <div className="text-right">
        {_.get(newBusinessLinesInfo, 'attributes.is_active') ? (
          <button
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary ml-1"
            onClick={handleDeactivate}
          >
            Deactivate
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary ml-1"
            onClick={handleActivate}
          >
            Activate
          </button>
        )}
        <a
          className="btn btn-primary cms-bg-color-primary cms-outline-primary  ml-1   "
          href="#/"
          onClick={handleDownload}
        >
          <i className="fas fa-print" /> Generate PDF
        </a>

        <button
          onClick={handleUpdateBusinessLines}
          type="button"
          className="btn-blank"
        >
          <i className="far fa-edit icon-edit" />
        </button>
        <button
          type="button"
          className="btn-blank"
          onClick={handleRemoveBusinessLines}
        >
          <i className="far fa-trash-alt icon-delete" />
        </button>
      </div>
      <table className="transaction-table table table-borderless table-sm">
        <tbody>
          <tr>
            <td className="text-dark" width="150">
              Code
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b className="text-success">{_.get(formData, 'code')}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="150">
              Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b className="text-success" style={{ lineBreak: 'anywhere' }}>
                {_.get(newBusinessLinesInfo, 'attributes.name')}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="150">
              Is Active?
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b className="text-success">
                {_.get(newBusinessLinesInfo, 'attributes.is_active')
                  ? 'Yes'
                  : 'No'}
              </b>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
      <TaxRevenueInformation data={newBusinessLinesInfo} />

      {!isEmpty(otherFees) && (
        <div>
          <hr />
          <h5 className="text-dark">Other Fees</h5>
          <div className="table-responsive">
            <table className="table table-bordered rounded">
              <tbody>
                {otherFees.map((fee) => (
                  <tr key={fee.id}>
                    <td>
                      <div className="d-flex align-items-center">
                        <h3
                          className="text-dark mr-3 mb-0 font-weight-bold"
                          style={{ fontSize: '1rem' }}
                        >
                          {_.get(fee, 'attributes.name')}
                        </h3>{' '}
                        <span
                          className="text-muted"
                          style={{ fontSize: '.8rem' }}
                        >
                          {_.get(fee, 'attributes.description')}
                        </span>
                      </div>
                    </td>
                    <td>
                      <b className="text-success">
                        ₱ {_.get(fee, 'attributes.amount_human')}
                      </b>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="d-flex justify-content-center">
        <button
          type="button"
          onClick={closeModal}
          className="mt-3 btn btn-dark "
        >
          <span className="font-weight-bold">Cancel</span>
        </button>
      </div>
    </Modal.Body>
  );
}

ViewBusinessLinesModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  removeNewBusinessLines: PropTypes.instanceOf(Function).isRequired,
  businessLinesId: PropTypes.string.isRequired,
  businessLinesInfo: PropTypes.instanceOf(Object).isRequired,
  getNewBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  newBusinessNaturesId: PropTypes.string.isRequired,
  getSingleNewBusinessLines: PropTypes.instanceOf(Function).isRequired,
  newBusinessLinesInfo: PropTypes.instanceOf(Object).isRequired,
  activateNewBusinessLines: PropTypes.instanceOf(Function).isRequired,
  deactivateNewBusinessLines: PropTypes.instanceOf(Function).isRequired,
  getNewBusinessNaturesList: PropTypes.instanceOf(Function).isRequired,
  getSingleNewBusinessNatures: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  newBusinessLinesInfo:
    _.get(api, `${c.GET_SINGLE_NEW_BUSINESS_LINES}.item`) || {},
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewBusinessLinesModal);
